/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { AcceptInvitationDto } from '../dtos/acceptInvitationDto.interface';
import type { GetInvitationDto } from '../dtos/getInvitationDto.interface';
import { ISetOrResetPasswordRequest } from '../interfaces/set-or-reset-password-request.interface';
/**
 * The createAction function returns a function, that when called returns an object in the shape
 * of the Action interface. The props method is used to define any additional metadata needed
 * for the handling of the action.
 */

export const invitation = createActionGroup({
    source: '[Aumico-Users] invitation',
    events: {
        get: props<{ payload: string }>(),
        'get success': props<{ payload: GetInvitationDto }>(),
        'get failure': props<{ payload: HttpErrorResponse }>(),
        'Accept Invitation': props<{
            payload: {
                uuid: string;
                acceptInvitationDto: AcceptInvitationDto;
                setPassword: ISetOrResetPasswordRequest;
            };
        }>(),
        'Accept Invitation Success': props<{ payload: string }>(),
        'Accept Invitation Failure': props<{ payload: HttpErrorResponse }>(),
    },
});
